export enum TrackingEvent {
  Loaded = `Load`,
  CellClick = `Cell Click`,
  SelectionChange = `Selection Change`,
  SortChange = `Sort Change`,
  ProgressiveScroll = `Progressive Scroll`,
}
